<template>
	<span
		class="relative ml-3 before:absolute before:left-[-12px] before:top-1/2 before:size-1 before:-translate-y-1/2 before:bg-beige first:ml-0 first:before:content-none"
	>
		<slot />
	</span>
</template>
<script setup lang="ts"></script>
